import Component from '../classes/Component'
import Player from '@vimeo/player'
import gsap from 'gsap/all'

export default class extends Component {
  constructor (element, DJ) {
    super({
      classes: {},
      element: element,
      elements: {
        overlay: '.program-video__overlay',
        button: '.program-video__overlay__button',
        coverVideo: '.program-video__videos__cover',
        mainVideo: '.program-video__main'
      }
    })

    this.playing = false
    this.player = new Player(this.elements.mainVideo)
    this.DJ = DJ
  }

  addEventListeners () {
    this.elements.overlay.addEventListener('click', () => {
      this.toggleVideo()
    })
    this.elements.overlay.addEventListener('mouseleave', () => {
      gsap.to(this.elements.button, {
        left: '50%',
        top: '50%',
        duration: 0.5,
        rotate: '0',
        ease: 'power1.out'
      })
      gsap.to(this.elements.button, {
        duration: 0.3,
        opacity: 1,
        ease: 'power1.out'
      })
      this.pauseVideo()
    })
    this.elements.overlay.addEventListener('mousemove', (e) => {
      const bounds = e.target.getBoundingClientRect()
      const x = e.clientX - bounds.left
      const rotation = e.movementX * 0.3
      const y = e.clientY - bounds.top
      gsap.to(this.elements.button, {
        left: x,
        top: y,
        duration: 0.5,
        rotate: `${rotation}deg`,
        ease: 'power1.out'
      })
      window.clearTimeout(this.circleRotateTimeout)
      this.circleRotateTimeout = setTimeout(() => {
        gsap.to(this.elements.button, {
          duration: 1,
          rotate: '0deg',
          ease: 'power1.out'
        })
      }, 500)
      gsap.to(this.elements.button, {
        duration: 0.3,
        opacity: 1,
        ease: 'power1.out'
      })
      window.clearTimeout(this.hideTimeout)
      this.hideTimeout = setTimeout(() => {
        if (this.playing) {
          gsap.to(this.elements.button, {
            duration: 0.3,
            opacity: 0,
            ease: 'power1.out'
          })
        }
      }, 2000)
    })
  }

  toggleVideo () {
    this.elements.button.classList.toggle('playing')
    if (this.playing) {
      this.pauseVideo()
    } else {
      this.playVideo()
    }
  }

  pauseVideo () {
    this.DJ.dampen(false)
    gsap.to(this.elements.coverVideo, {
      scale: 1,
      opacity: 1,
      duration: 0.6,
      ease: 'expo.inOut'
    })
    gsap.to(this.elements.mainVideo, {
      scale: 1.25,
      opacity: 0,
      duration: 0.6,
      ease: 'expo.inOut'
    })
    this.playing = false
    this.player.pause()
  }

  playVideo () {
    this.DJ.dampen(true)
    gsap.to(this.elements.mainVideo, {
      scale: 1,
      opacity: 1,
      duration: 0.6,
      ease: 'expo.inOut'
    })
    gsap.to(this.elements.coverVideo, {
      scale: 1.25,
      opacity: 0,
      duration: 0.6,
      ease: 'expo.inOut'
    })
    this.playing = true
    this.player.play()
  }

  onResize () {

  }
}
